module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "width": "60%"
    }
  }, [(_vm.audit_status == 2) ? _c('div', {
    staticClass: "red pb20"
  }, [_c('p', [_vm._v("审核失败，原因如下：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.audit_tips))])]) : _vm._e(), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "size": "mini",
      "label-width": "170px",
      "rules": _vm.rules,
      "disabled": _vm.audit_status == '0' || _vm.audit_status == 1 || _vm.audit_status == 3 || _vm.audit_status == 4 || _vm.audit_status == 5
    }
  }, [_c('div', {
    staticClass: "f16 bold pb20"
  }, [_vm._v("1、商家账户信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商户邮箱",
      "prop": "email"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    商户邮箱\n                    "), _c('el-tooltip', {
    attrs: {
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            邮箱是商户的快钱账号，后续会接收来自快钱的激活邮件，每个商户邮箱都是唯一不可重复的\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-question primary"
  })])], 1), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结算账号类型",
      "prop": "settleAccType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    结算账号类型\n                    "), _c('el-tooltip', {
    attrs: {
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            若银行账号为商户本人账号，则选择法人即可（多数情况）；"), _c('br'), _vm._v("\n                            若后面银行账号为对公账号，则选择企业；"), _c('br'), _vm._v("\n                            若打款账号非商户自己账号而是授权给别人或公司，则选择授权人或对公授权人；\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-question primary"
  })])], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.settleAccType),
      callback: function($$v) {
        _vm.$set(_vm.form, "settleAccType", $$v)
      },
      expression: "form.settleAccType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "企业",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "法人",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "授权人",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "对公授权人",
      "value": 3
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.settleAccType == 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('div', {
    staticClass: "red f12",
    staticStyle: {
      "line-height": "20px"
    }
  }, [_vm._v("\n                      法人结算类型下需要单独告知快钱进件人员，请务必在完成系统进件信息提交后，将商户账号（邮箱账号）告知对接的快钱进件人员\n                    ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.form.settleAccType == 2) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('div', {
    staticClass: "red f12",
    staticStyle: {
      "line-height": "20px"
    }
  }, [_c('p', [_vm._v("授权人结算类型下需要额外提供两份材料，请在完成系统进件信息提交后，将商户账号（邮箱账号）+两份材料发给对接的快钱进件人员：")]), _vm._v(" "), _c('p', [_vm._v("1、商户提供结算意愿确认函 ，需盖章；"), _c('a', {
    staticClass: "cursor primary",
    attrs: {
      "href": "http://qnvideo.anlaiye.com.cn/853d484af8d44c8a8da987025779ed3a.doc"
    }
  }, [_vm._v("点击下载模板")])]), _vm._v(" "), _c('p', [_vm._v("2、商户和授权人出具的关系说明（商户自拟），两个主体都要在上面盖章；")])])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证人像面照片",
      "prop": "authIdCardPersonFssId"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'authIdCardPerson')
      }
    }
  }, [(_vm.form.authIdCardPerson) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.authIdCardPerson)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.authIdCardPerson) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.authIdCardPerson
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证国徽面照片",
      "prop": "authIdCardNationalFssId"
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'authIdCardNational')
      }
    }
  }, [(_vm.form.authIdCardNational) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.authIdCardNational)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.authIdCardNational) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.authIdCardNational
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授权人姓名",
      "prop": "authIdCardName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.authIdCardName),
      callback: function($$v) {
        _vm.$set(_vm.form, "authIdCardName", $$v)
      },
      expression: "form.authIdCardName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授权人身份证号",
      "prop": "authIdCardNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "18",
      "placeholder": "请输入请输入15位或者18位身份证号",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.authIdCardNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "authIdCardNumber", $$v)
      },
      expression: "form.authIdCardNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期开始时间",
      "prop": "authIdCardBeginDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.authIdCardBeginDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "authIdCardBeginDate", $$v)
      },
      expression: "form.authIdCardBeginDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期结束时间",
      "prop": "authIdCardExpireDate"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.authIdCardExpireDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "authIdCardExpireDate", $$v)
      },
      expression: "form.authIdCardExpireDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "授权人手机号",
      "prop": "authTel"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.authTel),
      callback: function($$v) {
        _vm.$set(_vm.form, "authTel", $$v)
      },
      expression: "form.authTel"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行账号",
      "prop": "pay_account"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.pay_account),
      callback: function($$v) {
        _vm.$set(_vm.form, "pay_account", $$v)
      },
      expression: "form.pay_account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "账户名称",
      "prop": "pay_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.pay_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "pay_name", $$v)
      },
      expression: "form.pay_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "银行名称",
      "prop": "bank_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "请输入银行"
    },
    on: {
      "change": function($event) {
        return _vm.getBankBranch()
      }
    },
    model: {
      value: (_vm.form.bank_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "bank_id", $$v)
      },
      expression: "form.bank_id"
    }
  }, _vm._l((_vm.banks), function(p) {
    return _c('el-option', {
      key: p.k,
      attrs: {
        "label": p.n,
        "value": p.k
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支行全称",
      "prop": "bank_branch_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "reserve-keyword": "",
      "placeholder": "请输入支行",
      "loading": _vm.loading,
      "remote-method": _vm.bankRemoteMethod
    },
    on: {
      "change": function($event) {
        return _vm.getBranchName()
      }
    },
    model: {
      value: (_vm.form.bank_branch_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "bank_branch_id", $$v)
      },
      expression: "form.bank_branch_id"
    }
  }, _vm._l((_vm.bankBranchs), function(item) {
    return _c('el-option', {
      key: item.k,
      attrs: {
        "label": item.n,
        "value": item.k
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户行区域",
      "prop": "bank_area"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.distinctData,
      "props": {
        value: 'id'
      }
    },
    model: {
      value: (_vm.form.bank_area),
      callback: function($$v) {
        _vm.$set(_vm.form, "bank_area", $$v)
      },
      expression: "form.bank_area"
    }
  })], 1), _vm._v(" "), (_vm.form.settleAccType == 1 || _vm.form.settleAccType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "开户行手机号",
      "prop": "pay_mp"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.pay_mp),
      callback: function($$v) {
        _vm.$set(_vm.form, "pay_mp", $$v)
      },
      expression: "form.pay_mp"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.form.settleAccType == 2 || _vm.form.settleAccType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "银行卡照片",
      "prop": "bankCardFssId",
      "rules": [{
        required: true,
        message: '请上传银行卡照片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'bankCard')
      }
    }
  }, [(_vm.form.bankCard) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.bankCard)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.bankCard) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.bankCard
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "f16 bold pb20"
  }, [_vm._v("2、商户主体资料")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主体类型",
      "prop": "subjectType"
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    主体类型\n                    "), _c('el-tooltip', {
    attrs: {
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            非公司企业商户直接选择个体工商户即可（多数情况）;"), _c('br'), _vm._v("\n                            若为公司企业则根据公司企业性质选择对应主体类型\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-question primary"
  })])], 1), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.changeSubjectType()
      }
    },
    model: {
      value: (_vm.form.subjectType),
      callback: function($$v) {
        _vm.$set(_vm.form, "subjectType", $$v)
      },
      expression: "form.subjectType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "小微/小个体",
      "value": 0
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "有限责任公司",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "股份有限责任公司",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "私营合伙企业",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "私营独资企业",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "个体工商户",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "非公司企业法人",
      "value": 6
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.subjectType == 1 || _vm.form.subjectType == 2 || _vm.form.subjectType == 3 || _vm.form.subjectType == 4 || _vm.form.subjectType == 5) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "营业执照照片",
      "prop": "licensePicFssId",
      "rules": [{
        required: true,
        message: '请选择营业执照照片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'licensePic')
      }
    }
  }, [(_vm.form.licensePic) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.licensePic)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.licensePic) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.licensePic
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册号/统一社会信用代码",
      "prop": "businessRegno",
      "rules": [{
        required: true,
        message: '请输入注册号/统一社会信用代码'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "18",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.businessRegno),
      callback: function($$v) {
        _vm.$set(_vm.form, "businessRegno", $$v)
      },
      expression: "form.businessRegno"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商户名称",
      "prop": "merchantName",
      "rules": [{
        required: true,
        message: '请输入商户名称'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.merchantName),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantName", $$v)
      },
      expression: "form.merchantName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法人姓名/个体户经营者",
      "prop": "legalName",
      "rules": [{
        required: true,
        message: '请输入法人姓名/个体户经营者'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.legalName),
      callback: function($$v) {
        _vm.$set(_vm.form, "legalName", $$v)
      },
      expression: "form.legalName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营范围",
      "prop": "merchantConstraintBusiness",
      "rules": [{
        required: true,
        message: '请输入经营范围'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.merchantConstraintBusiness),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantConstraintBusiness", $$v)
      },
      expression: "form.merchantConstraintBusiness"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营场所地区编码",
      "prop": "merchantArea",
      "rules": [{
        required: true,
        message: '请选择经营场所地区'
      }]
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.distinctData,
      "props": {
        value: 'id'
      }
    },
    model: {
      value: (_vm.form.merchantArea),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantArea", $$v)
      },
      expression: "form.merchantArea"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营地址",
      "prop": "merchantAddress",
      "rules": [{
        required: true,
        message: '请输入经营地址'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.merchantAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantAddress", $$v)
      },
      expression: "form.merchantAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业证起始时间",
      "prop": "licenseHandleDate",
      "rules": [{
        required: true,
        message: '请选择时间'
      }]
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.licenseHandleDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "licenseHandleDate", $$v)
      },
      expression: "form.licenseHandleDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业证结束时间",
      "prop": "licenseCancelDate",
      "rules": [{
        required: true,
        message: '请选择时间'
      }]
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.licenseCancelDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "licenseCancelDate", $$v)
      },
      expression: "form.licenseCancelDate"
    }
  })], 1), _vm._v(" "), (_vm.form.businessRegno.length == 15) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "组织机构代码证照片",
      "prop": "orgFssId",
      "rules": [{
        required: true,
        message: '请选择组织机构代码证照片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'org')
      }
    }
  }, [(_vm.form.org) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.org)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.org) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.org
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "组织机构代码",
      "prop": "orgCode",
      "rules": [{
        required: true,
        message: '请输入组织机构代码'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.orgCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "orgCode", $$v)
      },
      expression: "form.orgCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "税务登记证照片",
      "prop": "taxFssId",
      "rules": [{
        required: true,
        message: '请选择税务登记证照片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'tax')
      }
    }
  }, [(_vm.form.tax) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.tax)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.tax) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.tax
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "税务登记证代码",
      "prop": "taxCode",
      "rules": [{
        required: true,
        message: '请输入税务登记证代码'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.taxCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "taxCode", $$v)
      },
      expression: "form.taxCode"
    }
  })], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.form.subjectType == 6) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "证书类型",
      "prop": "merchantCertType",
      "rules": [{
        required: true,
        message: '请选择证书类型'
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.merchantCertType),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantCertType", $$v)
      },
      expression: "form.merchantCertType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "非营业执照（含事业单位法人证等）",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "事业单位法人证书",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "民办非企业单位登记证书",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "社会团体法人登记证书",
      "value": 5
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": 6
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登记证书照片",
      "prop": "licensePicFssId",
      "rules": [{
        required: true,
        message: '请选择登记证书照片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'licensePic')
      }
    }
  }, [(_vm.form.licensePic) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.licensePic)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.licensePic) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.licensePic
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登记证书号",
      "prop": "businessRegno",
      "rules": [{
        required: true,
        message: '请输入登记证书号'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.businessRegno),
      callback: function($$v) {
        _vm.$set(_vm.form, "businessRegno", $$v)
      },
      expression: "form.businessRegno"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营单位名称",
      "prop": "merchantName",
      "rules": [{
        required: true,
        message: '请输入经营单位名称'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.merchantName),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantName", $$v)
      },
      expression: "form.merchantName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "法定代表人",
      "prop": "legalName",
      "rules": [{
        required: true,
        message: '请输入法定代表人'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.legalName),
      callback: function($$v) {
        _vm.$set(_vm.form, "legalName", $$v)
      },
      expression: "form.legalName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营范围",
      "prop": "merchantConstraintBusiness",
      "rules": [{
        required: true,
        message: '请输入经营范围'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.merchantConstraintBusiness),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantConstraintBusiness", $$v)
      },
      expression: "form.merchantConstraintBusiness"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营场所地区编码",
      "prop": "merchantArea",
      "rules": [{
        required: true,
        message: '请选择经营场所地区'
      }]
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.distinctData,
      "props": {
        value: 'id'
      }
    },
    model: {
      value: (_vm.form.merchantArea),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantArea", $$v)
      },
      expression: "form.merchantArea"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册地址",
      "prop": "merchantAddress",
      "rules": [{
        required: true,
        message: '请输入注册地址'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.merchantAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantAddress", $$v)
      },
      expression: "form.merchantAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登记证起始时间",
      "prop": "licenseHandleDate",
      "rules": [{
        required: true,
        message: '请选择时间'
      }]
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.licenseHandleDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "licenseHandleDate", $$v)
      },
      expression: "form.licenseHandleDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登记证结束时间",
      "prop": "licenseCancelDate",
      "rules": [{
        required: true,
        message: '请选择时间'
      }]
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.licenseCancelDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "licenseCancelDate", $$v)
      },
      expression: "form.licenseCancelDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.subjectType === 0) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "prop": "merchantName",
      "rules": [{
        required: true,
        message: '请输入客户名称'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.merchantName),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantName", $$v)
      },
      expression: "form.merchantName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营地址",
      "prop": "merchantAddress",
      "rules": [{
        required: true,
        message: '请输入经营地址'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.merchantAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantAddress", $$v)
      },
      expression: "form.merchantAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营场所地区编码",
      "prop": "merchantArea",
      "rules": [{
        required: true,
        message: '请选择经营场所地区'
      }]
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.distinctData,
      "props": {
        value: 'id'
      }
    },
    model: {
      value: (_vm.form.merchantArea),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantArea", $$v)
      },
      expression: "form.merchantArea"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营范围",
      "prop": "merchantConstraintBusiness",
      "rules": [{
        required: true,
        message: '请输入经营范围'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.merchantConstraintBusiness),
      callback: function($$v) {
        _vm.$set(_vm.form, "merchantConstraintBusiness", $$v)
      },
      expression: "form.merchantConstraintBusiness"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.subjectType == 1 || _vm.form.subjectType == 2 || _vm.form.subjectType == 3 || _vm.form.subjectType == 4 || _vm.form.subjectType == 6) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "开户凭证照片",
      "prop": "accOpenFssId",
      "rules": [{
        required: true,
        message: '请选择开户凭证照片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'accOpen')
      }
    }
  }, [(_vm.form.accOpen) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.accOpen)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.accOpen) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.accOpen
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户凭证代码",
      "prop": "accOpenCode",
      "rules": [{
        required: true,
        message: '请输入开户凭证代码'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.accOpenCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "accOpenCode", $$v)
      },
      expression: "form.accOpenCode"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营者/法人手机号",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "11",
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", $$v)
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证类型",
      "prop": "idType",
      "rules": [{
        required: true,
        message: '请选择身份证类型'
      }]
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.idType),
      callback: function($$v) {
        _vm.$set(_vm.form, "idType", $$v)
      },
      expression: "form.idType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "居民身份证",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "港澳通行证",
      "value": 2
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "台胞证",
      "value": 3
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外籍护照",
      "value": 4
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他",
      "value": 9
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.idType == 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "身份证人像面照片",
      "prop": "idCardPersonFssId",
      "rules": [{
        required: true,
        message: '请选择身份证人像面照片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'idCardPerson')
      }
    }
  }, [(_vm.form.idCardPerson) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.idCardPerson)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.idCardPerson) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.idCardPerson
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证国徽面照片",
      "prop": "idCardNationalFssId",
      "rules": [{
        required: true,
        message: '请选择身份证国徽面照片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'idCardNational')
      }
    }
  }, [(_vm.form.idCardNational) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.idCardNational)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.idCardNational) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.idCardNational
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "idCardName",
      "rules": [{
        required: true,
        message: '请输入姓名'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.idCardName),
      callback: function($$v) {
        _vm.$set(_vm.form, "idCardName", $$v)
      },
      expression: "form.idCardName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "idCardNumber",
      "rules": [{
        required: true,
        message: '请输入身份证号'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": "18",
      "placeholder": "请输入15位或者18位身份证号",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.idCardNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "idCardNumber", $$v)
      },
      expression: "form.idCardNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期开始时间",
      "prop": "idCardBeginDate",
      "rules": [{
        required: true,
        message: '请选择时间'
      }]
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.idCardBeginDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "idCardBeginDate", $$v)
      },
      expression: "form.idCardBeginDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期结束时间",
      "prop": "idCardExpireDate",
      "rules": [{
        required: true,
        message: '请选择时间'
      }]
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.idCardExpireDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "idCardExpireDate", $$v)
      },
      expression: "form.idCardExpireDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.idType == 2 || _vm.form.idType == 3 || _vm.form.idType == 4 || _vm.form.idType == 9) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "证件图片",
      "prop": "idDocFssId",
      "rules": [{
        required: true,
        message: '请选择证件图片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'idDoc')
      }
    }
  }, [(_vm.form.idDoc) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.idDoc)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.idDoc) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.idDoc
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证件姓名",
      "prop": "idCardName",
      "rules": [{
        required: true,
        message: '请输入证件姓名'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.idCardName),
      callback: function($$v) {
        _vm.$set(_vm.form, "idCardName", $$v)
      },
      expression: "form.idCardName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "证件号码",
      "prop": "idCardNumber",
      "rules": [{
        required: true,
        message: '请输入证件号码'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.idCardNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "idCardNumber", $$v)
      },
      expression: "form.idCardNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期开始时间",
      "prop": "idCardBeginDate",
      "rules": [{
        required: true,
        message: '请选择时间'
      }]
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.idCardBeginDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "idCardBeginDate", $$v)
      },
      expression: "form.idCardBeginDate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "有效期结束时间",
      "prop": "idCardExpireDate",
      "rules": [{
        required: true,
        message: '请选择时间'
      }]
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.idCardExpireDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "idCardExpireDate", $$v)
      },
      expression: "form.idCardExpireDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "f16 bold pb20"
  }, [_vm._v("3、商家账户信息")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店名称",
      "prop": "inDoorName",
      "rules": [{
        required: true,
        message: '请输入门店名称'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.inDoorName),
      callback: function($$v) {
        _vm.$set(_vm.form, "inDoorName", $$v)
      },
      expression: "form.inDoorName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店省市区域",
      "prop": "inDoorAreas",
      "rules": [{
        required: true,
        message: '请选择门店区域'
      }]
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "options": _vm.distinctData,
      "props": {
        value: 'id'
      }
    },
    model: {
      value: (_vm.form.inDoorAreas),
      callback: function($$v) {
        _vm.$set(_vm.form, "inDoorAreas", $$v)
      },
      expression: "form.inDoorAreas"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店地址",
      "prop": "inDoorAddress",
      "rules": [{
        required: true,
        message: '请输入门店地址'
      }]
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.inDoorAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "inDoorAddress", $$v)
      },
      expression: "form.inDoorAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门头照片",
      "prop": "headFssId",
      "rules": [{
        required: true,
        message: '请选择门头照片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'head')
      }
    }
  }, [(_vm.form.head) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.head)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.head) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.head
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "门店内景照片",
      "prop": "inDoorFssId",
      "rules": [{
        required: true,
        message: '请选择门店内景照片'
      }]
    }
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'inDoor')
      }
    }
  }, [(_vm.form.inDoor) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.inDoor)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.inDoor) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.inDoor
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "f16 bold pb20"
  }, [_vm._v("4、补充材料")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "租赁协议或产权证明",
      "prop": "additionFssId",
      "rules": [{
        required: true,
        message: '请选择租赁协议或产权证明'
      }]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    租赁协议或产权证明\n                    "), _c('el-tooltip', {
    attrs: {
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            商户证明经营地址为租赁或自有房产\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-question primary"
  })])], 1), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'addition')
      }
    }
  }, [(_vm.form.addition) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.addition)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.addition) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.addition
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户意愿确认函",
      "prop": "openWillFssId",
      "rules": [{
        required: true,
        message: '请选择开户意愿确认函'
      }]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    开户意愿确认函\n                    "), _c('el-tooltip', {
    attrs: {
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            需要先下载模板文件，打印出来让商户签字后，再拍照上传\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-question primary"
  })])], 1), _vm._v(" "), _c('a', {
    staticClass: "primary f12 cursor",
    attrs: {
      "href": "http://qnvideo.anlaiye.com.cn/59c0aeb4c0a84252af1746433aa43978.doc"
    }
  }, [_vm._v("点击下载开户确认函文件")]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'openWill')
      }
    }
  }, [(_vm.form.openWill) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.openWill)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.openWill) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.openWill
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), (_vm.form.settleAccType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "个人信息结算授权书",
      "prop": "personalSettleAuthFssId",
      "rules": [{
        required: true,
        message: '请选择个人信息结算授权书'
      }]
    }
  }, [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n                    个人信息结算授权书\n                    "), _c('el-tooltip', {
    attrs: {
      "placement": "right"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n                            个人信息单独同意授权书：需要先下载模板文件，打印出来让商家签字并加盖手印后，再拍照或扫描上传\n                        ")]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-question primary"
  })])], 1), _vm._v(" "), _c('a', {
    staticClass: "primary f12 cursor",
    attrs: {
      "href": "http://qnvideo.anlaiye.com.cn/9154c74ed5ed4b6eb139379055e6efcf.docx"
    }
  }, [_vm._v("点击下载个人信息结算授权书")]), _vm._v(" "), _c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "action": _vm.$apiUrl.imgUpload,
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload,
      "on-success": function (res, file) {
        return _vm.handleAvatarSuccess(res, file, 'personalSettleAuth')
      }
    }
  }, [(_vm.form.personalSettleAuth) ? _c('div', {
    staticClass: "icons"
  }, [_c('i', {
    staticClass: "el-icon-zoom-in",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handlePictureCardPreview(_vm.form.personalSettleAuth)
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "el-icon-upload2"
  })]) : _vm._e(), _vm._v(" "), (_vm.form.personalSettleAuth) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.personalSettleAuth
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('form')
      }
    }
  }, [_vm._v("提 交")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.resetForm('form')
      }
    }
  }, [_vm._v("重 置")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98eb4e4c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/saas/basic/bindKq.vue
// module id = 932
// module chunks = 0